import { c as _c } from "react/compiler-runtime";
import { motion, AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
interface Props {
  text: string;
}
export function CategoryDescription(props) {
  const $ = _c(21);
  const {
    t
  } = useTranslation("discounts");
  const [isExpanded, setIsExpanded] = useState(false);
  let t0;
  if ($[0] !== isExpanded) {
    t0 = () => {
      setIsExpanded(!isExpanded);
    };
    $[0] = isExpanded;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const toggleExpanded = t0;
  let t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      overflow: "hidden",
      cursor: "pointer"
    };
    t2 = {
      height: 32
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  const t3 = isExpanded ? "auto" : 32;
  let t4;
  if ($[4] !== t3) {
    t4 = {
      height: t3
    };
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      duration: 0.5
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== props.text) {
    t6 = <p className="mt-2 text-sm md:text-base">{props.text}</p>;
    $[7] = props.text;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t4 || $[10] !== t6) {
    t7 = <AnimatePresence initial={false}><motion.div style={t1} initial={t2} animate={t4} transition={t5}>{t6}</motion.div></AnimatePresence>;
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== isExpanded || $[13] !== t) {
    t8 = isExpanded ? t("category.showLess") : t("category.showMore");
    $[12] = isExpanded;
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t8 || $[16] !== toggleExpanded) {
    t9 = <button className="text-blue-500 underline" onClick={toggleExpanded}>{t8}</button>;
    $[15] = t8;
    $[16] = toggleExpanded;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t7 || $[19] !== t9) {
    t10 = <div>{t7}{t9}</div>;
    $[18] = t7;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
}